// extracted by mini-css-extract-plugin
export default {"inputSelectModal":"styles_inputSelectModal__0eqQF","formTitle":"styles_formTitle__g7Vaz","formHeaderIcon":"styles_formHeaderIcon__hPYYp"};